<style lang="scss" scoped>
.bots-header {
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  &__item {
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
  }
}
hr {
  border: 1px solid var(--color-background);
  /*border-top: 1px double darkgray;*/
  border-top: none;
  /*color: #333;*/
  overflow: visible;
  text-align: center;
  height: 0px;
  margin: 10px -20px;
}

.box1 {
  padding-top: 20px;
  padding-bottom: 30px;
  padding-left: 20px;
  padding-right: 20px;
}
.bots-table {
  /*padding: 0px 10px 10px 10px;*/
  border-collapse: collapse;
  width: 100%;
  /*margin-bottom: 20px;*/
}
.bots-table-header {
  border-bottom: 1px solid var(--color-border);
  padding: 10px;
  text-align: left;
  font-size: 12px;
  color: var(--color-text-dark);
}
.bots-table-cell {
  padding: 10px;
  text-align: left;
  font-size: 14px;
}
.bots-table-cellr {
  padding: 10px;
  text-align: right;
  font-size: 14px;
}
.tablerow {
  background-color: var(--color-card-dark);
  height: 102px;
  /*cursor: pointer;*/
}
.oddrow {
  background-color: var(--color-card);
}
.table-names {
  font-size: 8px;
  color: var(--color-text-dark);
  font-weight: bold;
}
.err {
  font-size: 10px;
  color: var(--color-danger-light);
}
.cursor1 {
  cursor: pointer;
}
.table-value-text {
  padding-left: 2px;
}
.table-names-top-padding {
  padding-top: 4px;
}
.action:hover {
  /*color: var(--color-accent-dark);*/
  /*text-decoration: underline;*/
  background: linear-gradient(to bottom left, var(--color-accent-dark), var(--color-accent));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.profitText {
  font-size: 14px;
  text-align: right;
}
.actionButton {
  font-size: 16px;
  /*size: 20px;*/
  cursor: pointer;
  /*padding: 10px;*/
  /*padding-right: 10px;*/
}
.notrades {
  text-align: center;
  color: var(--color-neutral-light);
  font-size: 16px;
}
.status-filter {
  width: 145px;
}
.notinrange {
  color: #a9a9a9;
}
.bot-hist-info-cell {
  text-align: left;
  font-size: 14px;
}

.vcenter {
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.hcenter {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.outer {
  mask-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
  pointer-events: none;
  user-select: none;
  cursor: not-allowed;
}

.headerviolet {
  font-size: 12px;
  color: var(--color-text-dark);
  font-weight: bold;
  padding-right: 5px;
  padding-left: 40px;
}

.filterBox {
  display: grid;
  grid-template-areas: 'acthist new immmrates symbol search symbolfilter statusfilter instruction';
  grid-template-columns: minmax(179px, 2fr) 2fr 1fr repeat(4, 2fr) 1fr;
  grid-gap: 15px;
  // display: flex;
  justify-content: space-between;
  align-items: center;
}
@media all and (max-width: 1000px) {
  .filterBox {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr 1fr;
    grid-template-areas:
      'acthist new symbol instruction'
      'search immmrates statusfilter symbolfilter';
  }
  #search {
    margin-left: 10px;
  }
  #new {
    margin-left: 30px;
  }
  #symbolfilter {
    margin-left: 30px;
    justify-self: flex-end;
  }
  #immmrates {
    margin-left: 80px;
  }
}
a:hover {
  text-decoration: underline;
}
#symbol {
  grid-area: symbol;
}
#symbolfilter {
  grid-area: symbolfilter;
}
#instruction {
  grid-area: instruction;
  justify-self: flex-end;
}
#new {
  grid-area: new;
}
#immmrates {
  grid-area: immmrates;
  justify-self: center;
}
#search {
  grid-area: search;
}
#statusfilter {
  grid-area: statusfilter;
}
#acthist {
  grid-area: acthist;
}
.base-asset-yellow {
  color: #FFD700;
}
// td {
//   border: 1px solid var(--color-success-light);
// }
// div {
//   border: 1px solid var(--color-success-light);
// }
</style>

<template>
  <div class="box box1" :class="{ outer: loading }">
    <OpenOrdersModal @on-cancel="$store.state.openOrdersModal.show = false" />
    <GridOrdersModal
      :show="botOrdersModalShow"
      :orders="botOrders"
      :botName="botName"
      :symbol="botSymbol"
      :profincoin="botProfincoin"
      @on-cancel="botOrdersModalShow = false"
    />
    <Confirm
      :show="confirmCnlBotModalShow"
      :text="confirmCnlBotModalText"
      :btname="confirmCnlBotModalBtnName"
      @on-cancel="confirmCnlBotModalShow = false"
      @confirmed="cancelBot(selectedBotId)"
    />
    <Confirm
      :show="confirmPanicSellBotModalShow"
      :text="confirmCnlBotModalText"
      :btname="confirmCnlBotModalBtnName"
      @on-cancel="confirmPanicSellBotModalShow = false"
      @confirmed="panicSellBot(selectedBotId)"
    />
    <!--      <EditBot :bot="selectEditBot" @on-cancel="hideEditBot" @confirmed="hideEditBot"/>-->
    <div class="filterBox">
      <RadioGroup
        id="acthist"
        style="min-width: 179px;"
        v-model="pendtype"
        type="button"
        size="default"
        @on-change="typeChanged"
      >
        <Radio
          label="act"
          style="font-size: 12px"
        >{{ $text.tr('АКТИВНЫЕ') }}</Radio>
        <Radio
          label="hist"
          style="font-size: 12px"
        >{{ $text.tr('ИСТОРИЯ') }}</Radio>
      </RadioGroup>
      <Button
        id="new"
        size="small"
        :disabled="$store.state.sys.tradeExchange.ExchId !== 'BYF'"
        long
        style="width: 130px; height: 30px;"
        @click="showNewBot"
      >
        <div>{{ $text.tr('НОВЫЙ GRID') }}</div>
      </Button>
      <div v-if="crosslev"
        id="immmrates"
        style="display: flex; flex-direction: row; align-items: start; justify-content: left; font-size: 13px; color: var(--color-text-dark); gap: 20px;"
      >
        <div v-if="imRate" :title="$text.tr('Initial Margin (IM) — начальная маржа. Минимальная сумма на счете, необходимая для открытия позиции.')">
          <span style="font-weight: bold;" >IM</span> <span :class="{'ggreen': parseFloat(imRate) < 80, 'gred': parseFloat(imRate) >= 80}">{{ imRate }}%</span>
        </div>
        <div v-if="mmRate"  :title="$text.tr('Maintenance Margin (MM) — поддерживающая маржа. Минимальная сумма, чтобы позиция не была ликвидирована.')">
          <span style="font-weight: bold;">MM</span> <span :class="{'ggreen': parseFloat(mmRate) < 80, 'gred': parseFloat(mmRate) >= 80}">{{ mmRate }}%</span>
        </div>
      </div>
      <SymbolsChooser
        id="symbol"
        v-model="symbol"
        :symbols="botSymbols"
        :disabled="$store.state.grids.editMode"
        @click="selectSymbol"
        selectStyle
      />
      <i-input
        id="search"
        v-model="searchTxt"
        @on-keydown="searchCanceled($event)"
        clearable
        :placeholder="$text.tr('поиск')"
        style="width: 177px;"
      ></i-input>
      <div
        id="symbolfilter"
        style="display: flex; align-items: center"
      >
        <Checkbox
          v-model="symbolFilter"
          size="large"
        ></Checkbox>
        <div style="font-size: 11px; text-align: left">{{ $text.tr('ФИЛЬТР ПО ПАРЕ') }}</div>
      </div>
      <!-- <div
        id="statusfilter"
        v-if="type === 'act'"
        style="text-align: left;"
      >
        <Select
          v-model="statusFilter"
          class="status-filter"
          size="default"
        >
          <Option
            v-for="(status, index) in actStatuses"
            :value="status.en"
            :key="'act-' + index"
            style="font-size: 18px;"
          >{{ $text.tr(status.ru) }}</Option>
        </Select>
      </div> -->
      <a
        id="instruction"
        :href="$text.tr('https://doc.capico.app/ru/features/grid')"
        target="_blank"
        style="color: #6b74e7; font-size: 14px;"
      >{{ $text.tr('ИНСТРУКЦИЯ') }}</a>
    </div>
    <div style="color: var(--color-neutral-light); margin-top: 10px; margin-bottom: 10px; margin-left: 8px; font-size: 12px; display: flex; flex-wrap: wrap; justify-content: center;">
      <template v-for="symbSC in shortcuts">
        <span
          :key="'symbsc-' + symbSC"
          style="border-bottom: 1px dashed var(--color-neutral-light); cursor: pointer; margin-right: 10px; margin-top: 2px"
          @click="shortcutClicked(symbSC)"
        >{{ symbSC }}</span>
      </template>
    </div>
    <div class="vcenter">
      <div class="headerviolet hcenter">{{ $text.tr('СУММА') }}</div>
      <div class="hcenter" :class="{'blur-balance': $store.state.sys.hideBalances}"><div>{{ gridsamount }}</div></div>
      <div class="headerviolet hcenter cursor1" @click="changeInfo">{{ gridinfo ? $text.tr('ГРИД APR') : $text.tr('APR') }}</div>
      <div class="hcenter cursor1" :class="{'gred': parseFloat(gridsapr) < 0, 'ggreen': parseFloat(gridsapr) >= 0}" @click="changeInfo"> {{ gridsapr }}%</div>
      <div class="headerviolet hcenter cursor1" @click="changeInfo">{{ gridinfo ? $text.tr('ГРИД ПРОФИТ') : $text.tr('ПРОФИТ') }}</div>
      <div class="hcenter cursor1" :class="{'gred': parseFloat(gridsprofit) < 0, 'ggreen': parseFloat(gridsprofit) >= 0, 'blur-balance': $store.state.sys.hideBalances}" @click="changeInfo"><div>{{ gridsprofit }}</div></div>
    </div>
    <hr />
    <!-- <div class="bots-header">
      <div
        v-for="(sort1, index) in sortBy"
        :key="index + '-' + sort.field"
      >
        <span
          class="bots-header__item"
          @click="sortList(sort1.field)"
        >{{
              $text.tr(sort1.name)
            }}</span>
        <div style="display: inline-block; width: 5px">
          <Icon
            v-if="sort.field === sort1.field && sort.direction === 1"
            type="md-arrow-dropup"
          />
          <Icon
            v-if="sort.field === sort1.field && sort.direction === -1"
            type="md-arrow-dropdown"
          />
        </div>
      </div>
    </div>
    <hr /> -->
    <table class="bots-table">
      <tr>
        <div style="
              width: 100%;
              display: flex;
              justify-content: space-around;
              flex-wrap: wrap;
            ">
        </div>
      </tr>
      <tr
        v-if="gridsFiltered.length === 0"
        class="notrades"
      >
        <td colspan="8">
          <div style="padding-top: 25px;">{{ $text.tr('Нет ботов') }}</div>
        </td>
      </tr>
      <template v-for="(bot, index) in gridsFiltered">
        <tr
          :key="bot.id"
          class="tablerow"
          :class="{'oddrow': index % 2 === 0, 'notinrange': !bot.inrange}"
        >
          <td class="bots-table-cell">
            <div style="display: flex; align-items: center;">
              <div style="height: 20px; width: 20px; margin-right: 3px">
                <CoinIcon :symbol="bot.symbol" />
              </div>
              <span
                class="action"
                v-on:click="editBot(bot)"
                style="cursor: pointer; font-size: 18px; font-weight: normal; margin-right: 3px"
              >
                <span :class="{'base-asset-yellow1': bot.profincoin}">{{ returnBaseAsset(bot.symbol) }}</span>/<span>{{ returnQuoteAsset(bot.symbol) }}</span>
              </span>
              <Icon
                style="cursor: pointer;"
                size="15"
                :title="$text.tr('Показать сделки')"
                type="ios-list-box-outline"
                color="var(--color-text-dark)"
                @click="getBotOrders(bot.id, bot.id, bot.symbol, bot.profincoin)"
              ></Icon>
            </div>
            <div
              class="table-names"
              style="font-size: 12px"
            >{{ bot.Name }}</div>
            <div style="font-size: 12px; cursor: pointer" @click="$copyToClipboardAndNotify(bot.id)">#{{ bot.id }}</div>
            <div style="font-size: 12px">{{ localTime(bot.created)[0] }} {{ localTime(bot.created)[1] }}</div>
          </td>
          <!--            <td class="bots-table-cell">{{ localTime(bot.Created)[0] }}<br>{{ localTime(bot.Created)[1] }}</td>-->
          <!--            <td class="bots-table-cell">{{ bot.Name }}</td>-->
          <!--            <td class="bots-table-cell">{{  returnSymbol(bot.symbol) }}</td>-->

                     <td class="bots-table-cell">
                       <table>
                        <tr>
                           <td class="table-names table-names-top-padding">{{ $text.tr('ЦЕНА МАКС') }}</td>
                           <td class="table-value-text">
                             {{ bot.max_price }} ({{ ((parseFloat(bot.max_price) - parseFloat(bot.min_price)) * 100 / parseFloat(bot.min_price)).toFixed(1) }}%)
                           </td>
                         </tr>
                         <tr>
                           <td class="table-names table-names-top-padding">{{ $text.tr('ЦЕНА МИН') }}</td>
                           <td class="table-value-text">
                             {{ bot.min_price }}
                           </td>
                         </tr>
                         <tr>
                           <td class="table-names table-names-top-padding">{{ $text.tr('ОРДЕРОВ') }}</td>
                           <td class="table-value-text">
                             {{ bot.grids }} ({{ (((parseFloat(bot.max_price) - parseFloat(bot.min_price)) * 100 / parseFloat(bot.min_price)) / bot.grids).toFixed(2) }}%)
                           </td>
                         </tr>
                         <!-- <tr v-if="bot.Status !== 'OFF'">
                           <td class="table-names table-names-top-padding">СЕЙЧАС</td>
                           <td class="table-value-text" :class="{gwhite: bot.Stage === 'WAITBUY', ggreen: parseFloat(bot.Last) >= parseFloat(bot.BuyPrice), gred: parseFloat(bot.Last) < parseFloat(bot.BuyPrice)}">
                             {{ bot.Last }} ({{ ((parseFloat(bot.Last) - parseFloat(bot.BuyPrice)) * 100 / parseFloat(bot.BuyPrice)).toFixed(1) }}%)
                           </td>
                         </tr> -->
                       </table>
          <!--&lt;!&ndash;              <span class="table-names">ПОКУПКA</span> {{ bot.BuyPrice}} {{ returnQuoteAsset(bot.symbol)}}<br>&ndash;&gt;-->
          <!--&lt;!&ndash;              <span class="table-names">ПРОДАЖА</span> {{ bot.SellPrice }} {{ returnQuoteAsset(bot.symbol)}}&ndash;&gt;-->
                     </td>

          <td class="bots-table-cell">
            <div class="table-names">{{ $text.tr('ЦЕНА ВХОДА') }}</div>
            {{ bot.pos_price && bot.pos_price !== '0' ? parseFloat(bot.pos_price) : '&nbsp;' }}
          </td>
          <td class="bots-table-cell">
            <div class="table-names">{{ $text.tr('СУММА') }}</div>
            <div :class="{'blur-balance': $store.state.sys.hideBalances}"><div>{{ parseFloat(bot.invested).toFixed(2) }} {{ returnQuoteAsset(bot.symbol) }}</div></div>
          </td>
          <td class="bots-table-cell">
            <div class="table-names">{{ $text.tr('СДЕЛОК') }}</div>
            {{ bot.trades }}
          </td>
          <td v-if="gridinfo" class="bots-table-cellr cursor1" style="width: 150px;" @click="changeInfo">
            <div class="table-names">{{ $text.tr('ГРИД APR') }}</div>
            <div
              class="profitText"
              style="text-align: right"
              :class="{'gred': parseFloat(bot.profit) < 0, 'ggreen': parseFloat(bot.profit) >= 0}">
              {{ parseFloat(bot.gridapr) }}%
            </div>
          </td>
          <td v-else class="bots-table-cellr cursor1" style="width: 150px;" @click="changeInfo">
            <div class="table-names">{{ $text.tr('APR') }}</div>
            <div
              class="profitText"
              style="text-align: right"
              :class="{'gred': parseFloat(bot.tprofit) < 0, 'ggreen': parseFloat(bot.tprofit) >= 0}">
              {{ parseFloat(bot.tapr) }}%
            </div>
          </td>
          <td v-if="gridinfo" class="bots-table-cellr cursor1" style="padding-right: 50px; width: 150px;" @click="changeInfo">
            <div class="table-names">{{ $text.tr('ГРИД ПРОФИТ') }}</div>
            <div
              class="profitText"
              style="text-align: right"
              :class="{'gred': parseFloat(bot.profit) < 0, 'ggreen': parseFloat(bot.profit) >= 0, 'blur-balance': $store.state.sys.hideBalances}">
              <div>{{ parseFloat(bot.profit).toFixed(2) }}</div>
            </div>
          </td>
          <td v-else class="bots-table-cellr cursor1" style="padding-right: 50px; width: 150px;" @click="changeInfo">
            <div class="table-names">{{ $text.tr('ПРОФИТ') }}</div>
            <div
              class="profitText"
              style="text-align: right"
              :class="{'gred': parseFloat(bot.tprofit) < 0, 'ggreen': parseFloat(bot.tprofit) >= 0, 'blur-balance': $store.state.sys.hideBalances}">
              <div>{{ parseFloat(bot.tprofit).toFixed(2) }}</div>
            </div>
          </td>
          <td v-if="type !== 'hist'" class="bots-table-cellr" style="width: 40px;">
            <!-- <div v-if="bot.profincoin" class="table-names">{{ $text.tr('МОНЕТ') }}</div> -->
            <div v-if="bot.profincoin" class="table-names">{{ returnBaseAsset(bot.symbol) }}</div>
            <div v-if="bot.profincoin && bot.coin_profit"
              class="profitText"
              style="text-align: right"
              :class="{'blur-balance': $store.state.sys.hideBalances}">
              <div>{{ parseFloat(bot.coin_profit).toFixed(2) }}</div>
            </div>
          </td>
          <td style="width: 100px;">
            <div v-if="bot.err && bot.err !== ''"
              class="gred">
              {{ returnBotErr(bot.err) }}
            </div>
          </td>
          <td>
            <Icon v-if="bot.err && bot.err === 'IB'"
              class="actionButton"
              :title="$text.tr('Выставить недостающие ордера')"
              type="md-sync"
              color="var(--color-danger-light)"
              @click="fixBuys(bot.id)"
            ></Icon>
          </td>
          <!-- <td style="padding-right: 40px">
            <div
              v-if="bot.tprofit"
              class="profitText"
              :class="{'gred': parseFloat(bot.tprofit) < 0, 'ggreen': parseFloat(bot.tprofit) >= 0}"
            >
              {{  parseFloat(bot.tprofit).toFixed(2) }} USDT
            </div>
          </td> -->
          <td>
            <Icon
              class="actionButton"
              :title="$text.tr('Скопировать грид')"
              type="md-document"
              color="var(--color-text-dark)"
              @click="showBotCopy(bot)"
            ></Icon>
          </td>
          <!-- <td>
            <Icon
              v-if="!botLoading[bot.Id] && bot.Status === 'ACT'"
              class="actionButton"
              :title="$text.tr('Остановить бота')"
              type="md-pause"
              color="var(--color-text-dark)"
              @click="pauseBot(bot.Id)"
            ></Icon>
            <Icon
              v-if="!botLoading[bot.Id] && bot.Status === 'PAU'"
              class="actionButton"
              :title="$text.tr('Включить бота')"
              type="md-play"
              color="var(--color-text-dark)"
              @click="startBot(bot.Id)"
            ></Icon> -->
            <!--              <pulse-loader :loading="true" color="var(--color-text-dark)" :size="'6px'"></pulse-loader><br>-->
            <!--              <scale-loader :loading="true" color="var(--color-text-dark)" :height="'10px'" :width="'2px'"></scale-loader><br>-->
            <!--              <grid-loader :loading="true" color="var(--color-text-dark)" :size="'3px'"></grid-loader><br>-->
            <!--              <beat-loader :loading="true" color="var(--color-text-dark)" :size="'6px'"></beat-loader><br>-->
            <!-- <clip-loader
              :loading="botLoading[bot.Id] === true"
              style="padding-top: 10px;"
              color="var(--color-text-dark)"
              :size="'16px'"
            ></clip-loader>
          </td> -->
          <td>
            <Icon
              v-if="type !== 'hist' && bot.Status !== 'C' && bot.pos_price !== '0'"
              class="actionButton"
              :title="$text.tr('Выключить грид и продать по рынку')"
              type="logo-usd"
              color="var(--color-text-dark)"
              @click="showPanicSellBotModal(bot.id)"
            ></Icon>
          </td>
          <td>
            <Icon
              v-if="type !== 'hist' && bot.status !== 'C'"
              class="actionButton"
              :title="$text.tr('Выключить грид и отменить все выставленные ордера')"
              type="md-close"
              size="18"
              color="var(--color-text-dark)"
              @click="showCancelBotModal(bot.id)"
            ></Icon>
            <!-- <div v-else style="width: 15px;"></div> -->
          </td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
import SymbolsChooser from '@/components/common/SymbolsChooser.vue'
import BotApi from '@/util/botapi'
import Grids from '@/services/grids'
import Confirm from '../../common/Confirm'
import GridOrdersModal from './GridOrdersModal'
import Bots from '@/services/bots'
import Vue from 'vue'
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
// import BeatLoader from 'vue-spinner/src/BeatLoader.vue'
// import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
// import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
// import GridLoader from 'vue-spinner/src/GridLoader.vue'
import ReconnectingWebSocket from 'reconnecting-websocket'
import Util from '@/util/util'
import OpenOrdersModal from '@/components/common/OpenOrdersModal'
import CoinIcon from '@/components/common/CoinIcon'
import common from '@/services/common'
import Decimal from 'decimal.js'

export default {
  name: 'GridList',
  components: {
    GridOrdersModal,
    Confirm,
    // ClipLoader,
    OpenOrdersModal,
    CoinIcon,
    SymbolsChooser
    // ScaleLoader,
    // BeatLoader,
    // PulseLoader,
    // GridLoader
  },
  data () {
    return {
      statusFilter: localStorage.getItem('capico_app_bot_act_status') || 'ALL',
      actStatuses: [
        { en: 'ALL', ru: 'Все' },
        { en: 'ACT', ru: 'Активные' },
        { en: 'WAITBUY', ru: 'Ожидает покупку' },
        { en: 'WAITSELL', ru: 'Ожидает продажу' },
        { en: 'PAU', ru: 'Остановлен' }
      ],
      symbolFilter:
        localStorage.getItem('capico_app_grid_symbol_filter') === 'true',
      searchTxt: '',
      confirmPanicSellBotModalShow: false,
      getBotListInterval: null,
      getMRateInterval: null,
      selectEditBot: {},
      botSymbol: '',
      botName: '',
      botOrders: [],
      botOrdersModalShow: false,
      botProfincoin: false,
      selectedBotId: '',
      confirmCnlBotModalBtnName: '',
      confirmCnlBotModalText: '',
      confirmCnlBotModalShow: false,
      pendtype: 'act',
      type: 'act',
      // shortcuts: ['BTC', 'ETH'],
      symbol: '',
      botLoading: {},
      zzz: false,
      gridinfo: false,
      loading: false,
      imRate: '',
      mmRate: '',
      crosslev: true,
      sort: {
        direction: -1,
        field: 'date'
      },
      sortBy: [
        { field: 'coin', name: 'МОНЕТА' },
        { field: 'date', name: 'ДАТА' },
        { field: 'invested', name: 'СУММА' },
        // { field: 'profitusd', name: 'ПРИБЫЛЬ $' },
        { field: 'profit', name: 'ГРИД ПРИБЫЛЬ' },
        { field: 'tprofit', name: 'ОБЩАЯ ПРИБЫЛЬ' }
      ]
    }
  },
  computed: {
    exchId () {
      return this.$store.state.sys.tradeExchange.ExchId
    },
    botSymbols () {
      return this.$store.state.data.symbols
    },
    shortcuts () {
      const newSC = []
      this.gridsdata.list.forEach(bot => {
        newSC.push(bot.symbol.replace('_USDT', ''))
      })
      const unique = newSC.filter((v, i, a) => a.indexOf(v) === i)
      return unique.sort(function (a, b) {
        return ('' + a).localeCompare(b)
      })
    },
    gridsamount () {
      return this.gridsFiltered.map(item => item.invested).reduce((prev, curr) => prev.add(new Decimal(curr)), new Decimal(0)).toDP(0)
    },
    gridsprofit () {
      if (this.gridinfo) {
        return this.gridsFiltered.map(item => item.profit).reduce((prev, curr) => prev.add(new Decimal(curr)), new Decimal(0)).toDP(2)
      } else {
        return this.gridsFiltered.map(item => item.tprofit).reduce((prev, curr) => prev.add(new Decimal(curr)), new Decimal(0)).toDP(2)
      }
    },
    gridsapr () {
      if (this.gridsamount.isZero()) {
        return new Decimal(0)
      }
      let yprofit
      if (this.gridinfo) {
        yprofit = this.gridsFiltered.map(item => new Decimal(item.invested).mul(item.gridapr).mul(0.01)).reduce((prev, curr) => prev.add(new Decimal(curr)), new Decimal(0)).toDP(2)
      } else {
        yprofit = this.gridsFiltered.map(item => new Decimal(item.invested).mul(item.tapr).mul(0.01)).reduce((prev, curr) => prev.add(new Decimal(curr)), new Decimal(0)).toDP(2)
      }
      return yprofit.div(this.gridsamount).mul(100).toDP(0)
    },
    gridsFiltered () {
      let list = []

      if (this.searchTxt !== '') {
        list = this.gridsdata.list.filter(bot => {
          if (
            bot.symbol.toLowerCase().includes(
              this.searchTxt.replace('/', '_').toLowerCase()
            )
          ) {
            return true
          }
          if (
            bot.id.toLowerCase().includes(
              this.searchTxt.replace('#', '').toLowerCase()
            )
          ) {
            return true
          }
          return false
        })
      } else if (this.symbolFilter) {
        list = this.gridsdata.list.filter(bot => {
          if (
            bot.symbol.toLowerCase().includes(
              this.$store.state.grids.symbol.replace('/', '_').toLowerCase()
            )
          ) {
            return true
          }
        })
      } else {
        list = this.gridsdata.list
      }
      // Sort by max_price DESC (highest first) only for active grids
      if (this.type === 'act') {
        return list.sort((a, b) => parseFloat(b.max_price) - parseFloat(a.max_price))
      }
      return list
    },
    gridsdata () {
      return this.$store.state.grids
    }
  },
  watch: {
    // statusFilter: function (value) {
    //   localStorage.setItem('capico_app_bot_act_status', value)
    // },
    symbolFilter: function (filter) {
      localStorage.setItem(
        'capico_app_grid_symbol_filter',
        JSON.stringify(filter)
      )
    },
    'gridsdata.symbol' (newSymbol) {
      this.symbol = newSymbol.replace('_', '/')
      // this.getActiveBotList()
    },
    $route (to, from) {
      // console.log('route:', to)
      if (to.name === 'grids') {
        this.getBotList()
        // this.createIntervals()
        // Bots.UpdateBotBalance()
      }
      if (from.name === 'grids') {
        // this.clearIntervals()
      }
    },
    '$store.state.sys.tradeExchange.Id': function () {
      // console.log('bot list tradeExchange changed')
      // this.botdata.editBot = {}
      this.$store.state.grids.editGrid = { type: 'close', editMode: false }
      this.getBotList()
      this.getMRate()
    },
    '$store.state.grids.gridsUpdated': function () {
      this.getBotList()
    }
  },
  methods: {
    sortList (field) {
      this.sort.field = field
      this.sort.direction = -1 * this.sort.direction
    },
    getMRate () {
      if (this.$router.currentRoute.name !== 'grids') {
        return
      }
      if (!this.$store.state.sys.tradeExchange.Id) {
        return
      }
      if (this.$store.state.sys.tradeExchange.ExchId !== 'BYF') {
        return
      }
      Grids.GetMRate(this.$store.state.sys.tradeExchange.Id)
        .then(response => {
          if (response.data !== null && !response.data.err) {
            this.imRate = response.data.im_rate || ''
            this.mmRate = response.data.mm_rate || ''
          } else {
            this.crosslev = false
          }
        })
        .catch(error => {
          console.log('getMRate error:', error)
        })
    },
    showOpenOrdersModal () {
      common.getOpenOrders()
    },
    pauseBot (botID) {
      const ref = this
      Vue.set(this.botLoading, botID, true)
      BotApi.get('bot/pause', {
        params: {
          token: this.$store.state.sys.token,
          id: botID
        }
      })
        .then(function (response) {
          // console.log(response.data)
          if (response.data !== null) {
            if (!response.data.err) {
              // ok
              ref.getBotList().then(() => {
                ref.botLoading[botID] = false
              })
              Bots.UpdateBotBalance()
            } else {
              // error
              ref.botLoading[botID] = false
              ref.$Notice.error({
                title: ref.$text.tr('Ошибка'),
                desc: Util.returnTextForErr(response.data.err),
                duration: 10
              })
            }
          }
        })
        .catch(function (error) {
          // error
          ref.botLoading[botID] = false
          console.log(error)
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(error),
            duration: 10
          })
        })
    },
    selectSymbol (symbol) {
      Grids.SelectGridsSymbol(symbol)
      // Bots.UpdateBotBalance()
    },
    shortcutClicked (symbol1) {
      // console.log('shortcutClicked', symbol1)
      this.$store.state.grids.editGrid = { type: 'close', editMode: false }
      // this.searchTxt = symbol.replace('_', '/')
      // this.symbol = symbol1 + '/USDT'
      Grids.SelectGridsSymbol(symbol1 + '/USDT')
      // Bots.UpdateBotBalance()
    },
    searchCanceled (e) {
      if (e.keyCode === 27) {
        this.searchTxt = ''
      }
    },
    typeChanged () {
      // this.botdata.botsList = []
      this.loading = true
      this.getBotList()
    },
    showPanicSellBotModal (botID) {
      this.selectedBotId = botID
      this.confirmCnlBotModalBtnName = this.$text.tr('ДА')
      this.confirmCnlBotModalText = this.$text.tr('Выключить грид и продать по рынку') + '?'
      this.confirmPanicSellBotModalShow = true
    },
    panicSellBot (gridId) {
      this.confirmPanicSellBotModalShow = false
      const ref = this
      Grids.CancelGrid(gridId, 1).then(function (response) {
        // console.log(response.data)
        if (response.data !== null) {
          if (!response.data.err) {
            // ok
            Grids.UpdateGridsBalance()
            ref.$Message.success({
              content: ref.$text.tr('Успешно!'),
              duration: 1
            })
            ref.gridsdata.gridsUpdated = Date.now()
          } else {
            // error
            ref.$Notice.error({
              title: ref.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
        }
      })
        .catch(function (error) {
          // error
          console.log(error)
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(error),
            duration: 10
          })
        })
    },
    returnProfitPctText (bot) {
      if (bot.Profit !== null) {
        return bot.Profit.Pct + '%'
      }
      return ''
    },
    returnProfitQuoteText (bot) {
      if (bot.Profit !== null) {
        // if (bot.Accumulate === 'B') {
        //   return bot.Profit.Base + ' ' + bot.symbol.split('_')[0]
        // }
        return bot.Profit.Quote + ' ' + this.returnQuoteAsset(bot.symbol)
      }
      return ''
    },
    returnProfitBaseText (bot) {
      if (bot.Profit !== null) {
        return bot.Profit.Base + ' ' + bot.symbol.split('_')[0]
      }
      return ''
    },
    startBot (botID) {
      const ref = this
      Vue.set(this.botLoading, botID, true)
      BotApi.get('bot/start', {
        params: {
          token: this.$store.state.sys.token,
          etid: this.$store.state.sys.tradeExchange.Id,
          id: botID
        }
      })
        .then(function (response) {
          // console.log(response.data)
          if (response.data !== null) {
            if (!response.data.err) {
              // ok
              ref.getBotList().then(() => {
                ref.botLoading[botID] = false
              })
              Bots.UpdateBotBalance()
            } else {
              // error
              ref.botLoading[botID] = false
              ref.$Notice.error({
                title: ref.$text.tr('Ошибка'),
                desc: Util.returnTextForErr(response.data.err),
                duration: 10
              })
              ref.getBotList()
            }
          }
        })
        .catch(function (error) {
          // error
          console.log(error)
          ref.botLoading[botID] = false
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(error),
            duration: 10
          })
        })
    },
    createIntervals () {
      this.getBotListInterval = setInterval(this.getBotList, 60000)
      this.getMRateInterval = setInterval(this.getMRate, 120000)
      // console.log('getBotList interval created')
    },
    clearIntervals () {
      clearInterval(this.getBotListInterval)
      clearInterval(this.getMRateInterval)
      // console.log('getBotList interval cleared')
    },
    editBot (bot) {
      Grids.SelectGridsSymbol(bot.symbol)
      // this.$store.state.bots.editBot = bot
      // this.$store.state.bots.editMode = true
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    getBotOrders (botID, botName, botSymbol, profincoin) {
      const ref = this
      Grids.GetGridExecs(botID, this.type === 'act' ? '' : '1')
        .then(function (response) {
          // console.log(response.data)
          if (response.data !== null) {
            if (!response.data.err) {
              // ok
              ref.botOrders = response.data
              ref.botName = botName
              ref.botSymbol = botSymbol
              ref.botProfincoin = profincoin || false
              ref.botOrdersModalShow = true
            } else {
              // error
              ref.$Notice.error({
                title: ref.$text.tr('Ошибка'),
                desc: Util.returnTextForErr(response.data.err),
                duration: 10
              })
            }
          } else {
            ref.$Notice.info({
              title: ref.$text.tr('нет ордеров'),
              duration: 1
            })
          }
        })
        .catch(function (error) {
          // error
          console.log(error)
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(error),
            duration: 10
          })
        })
    },
    cancelBot (gridId) {
      this.confirmCnlBotModalShow = false
      const ref = this
      Grids.CancelGrid(gridId).then(function (response) {
        // console.log(response.data)
        if (response.data !== null) {
          if (!response.data.err) {
            // ok
            Grids.UpdateGridsBalance()
            ref.$Message.success({
              content: ref.$text.tr('Grid выключен'),
              duration: 1
            })
            ref.gridsdata.gridsUpdated = Date.now()
          } else {
            // error
            ref.$Notice.error({
              title: ref.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
        }
      })
        .catch(function (error) {
          // error
          console.log(error)
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(error),
            duration: 10
          })
        })
    },
    showCancelBotModal (botID) {
      this.selectedBotId = botID
      this.confirmCnlBotModalBtnName = this.$text.tr('ДА')
      this.confirmCnlBotModalText = this.$text.tr('Выключить грид и отменить все выставленные ордера') + '?'
      this.confirmCnlBotModalShow = true
    },
    returnBotErr (err) {
      if (err === 'IB') {
        return this.$text.tr('Недостаточный баланс')
      }
    },
    returnBotClass (status, stage) {
      if (status === 'ACT') {
        return ''
      } else if (status === 'OFF') {
        return ''
      } else {
        return 'yellow'
      }
    },
    showNewBot () {
      this.$store.state.grids.editGrid = { type: 'new', editMode: true }
      // this.$store.state.grids.editBot = {}
    },
    showBotCopy (bot) {
      // console.log('bot:', JSON.stringify(bot))
      this.$store.state.grids.editGrid = {
        type: 'copy',
        editMode: true,
        symbol: bot.symbol,
        amount: bot.invested,
        minPrice: bot.min_price,
        maxPrice: bot.max_price,
        gridsNum: bot.grids,
        profitCollection: bot.profincoin ? 'COIN' : 'USDT'
      }
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    returnQuoteAsset (symbol) {
      const assets = symbol.split('_')
      return assets[1]
    },
    returnBaseAsset (symbol) {
      const assets = symbol.split('_')
      return assets[0]
    },
    returnSymbol (symbol) {
      const assets = symbol.split('_')
      return assets[0] + '/' + assets[1]
    },
    localTime (utctime) {
      return new Date(utctime)
        .toLocaleString('ru-RU')
        .replace(',', '')
        .split(' ')
    },
    changeInfo () {
      this.gridinfo = !this.gridinfo
      localStorage.setItem('capico_gridinfo', this.gridinfo)
    },
    fixBuys (gridId) {
      const ref = this
      Grids.FixBuys(gridId).then(function (response) {
        if (response.data !== null) {
          if (!response.data.err) {
            ref.$Message.success({
              content: ref.$text.tr('Успешно!'),
              duration: 2
            })
            ref.getBotList()
          } else {
            ref.$Notice.error({
              title: ref.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
        }
      })
        .catch(function (error) {
          console.log(error)
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(error),
            duration: 10
          })
        })
    },
    getBotList () {
      if (this.$router.currentRoute.name !== 'grids') {
        return
      }
      if (this.$store.state.sys.tradeExchange.ExchId !== 'BYF') {
        return
      }
      Grids.GetGridsByEtid(this.$store.state.sys.tradeExchange.Id, this.pendtype === 'act' ? '' : '1')
        .then(response => {
          // console.log('getBotList response:', response.data)
          if (response.data !== null) {
            if (!response.data.err) {
              // ok
              this.gridsdata.list = response.data
              // this.gridsdata.list.forEach(bot => {
              //   bot.symbol = bot.symbol.replace('_', '/')
              // })
            } else {
              // error
              this.$Notice.error({
                title: this.$text.tr('Ошибка'),
                desc: Util.returnTextForErr(response.data.err),
                duration: 10
              })
            }
          }
          this.type = this.pendtype
          this.loading = false
        })
        .catch(error => {
          // error
          console.log(error)
          this.$Notice.error({
            title: this.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(error),
            duration: 10
          })
          this.type = this.pendtype
          this.loading = false
        })
      // Bots.GetActiveBotList()
    }
  },
  created () {
    this.gridinfo = localStorage.getItem('capico_gridinfo') === 'true'
    this.symbol = this.$store.state.grids.symbol.replace('_', '/')
    this.getBotList()
    this.getMRate()
    this.createIntervals()
    // Bots.UpdateBotBalance()
    // this.initWs()
  },
  destroyed () {
    this.clearIntervals()
  }
}
</script>
